import { useState, useEffect } from 'react';

export interface DailyMetric {
  date: string;
  tx_count: number;
  avg_gas_gwei: number;
  daily_active_users: number;
  avg_block_time: number;
}

export interface DexVolume {
  date: string;
  dex_name: string;
  volume_usd: number;
  trade_count: number;
}

export interface MockData {
  daily_metrics: DailyMetric[];
  dex_volume: DexVolume[];
}

export function useMockData() {
  const [data, setData] = useState<MockData | null>(null);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    // API 호출 (프로덕션: Workers API, 로컬: localhost:8787)
    const API_BASE = import.meta.env.VITE_API_URL || 
      (import.meta.env.DEV ? 'http://localhost:8787' : 'https://worldchain-analytics-api.humanlabs.workers.dev');
    
    Promise.all([
      fetch(`${API_BASE}/api/metrics`).then(res => {
        if (!res.ok) throw new Error(`Failed to fetch metrics: ${res.statusText}`);
        return res.json();
      }),
      fetch(`${API_BASE}/api/dex`).then(res => {
        if (!res.ok) throw new Error(`Failed to fetch dex: ${res.statusText}`);
        return res.json();
      }),
    ])
      .then(([daily_metrics, dex_volume]) => {
        setData({ daily_metrics, dex_volume });
      })
      .catch(err => {
        console.error('Failed to load data:', err);
      })
      .finally(() => setLoading(false));
  }, []);
  
  return { data, loading };
}
